export const DetailDocumentView = ({ content = null }) => {


  if (!content) {
    return <h1>No se encontró el contenido</h1>
  }

  return <>
    <div className='p-2'>
      <img className='m-auto' src="/assets/img/icons/covid-icon.svg" alt="icono codigo de conducta" />
    </div>

    <div className='mt-4' dangerouslySetInnerHTML={{ __html: content?.hotelInformationLabel[0]?.description }}>
    </div>
  </>;
};
